import React from 'react';
import './AboutSection.css';

const AboutSection = () => (
  <section className="about-section">
    <div
      className="about-bg"
      style={{ background: "url('https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&q=80') center center/cover no-repeat" }}
    />
    <div className="about-overlay">
      <h2 className="about-title">About Derma Protec Films</h2>
      <p className="about-desc">
        For over two decades, Derma Protec has been at the forefront of window film innovation, combining cutting-edge nanotechnology with elegant design. Our premium films are engineered to provide superior UV protection, remarkable heat reduction, and timeless aesthetic appeal, trusted by luxury properties and vehicles worldwide.
      </p>
      <button className="about-btn">Read More</button>
    </div>
  </section>
);

export default AboutSection; 